import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { Lock as LockIcon, Check, HeartHandshake, ShieldCheck, Sparkles, Award, Infinity as InfinityIcon, Download } from 'lucide-react';
function useCountdown(hours: number) {
  const [timeLeft, setTimeLeft] = useState(hours * 60 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(t => t > 0 ? t - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const h = String(Math.floor(timeLeft / 3600)).padStart(2, '0');
  const m = String(Math.floor(timeLeft % 3600 / 60)).padStart(2, '0');
  const s = String(timeLeft % 60).padStart(2, '0');
  return {
    h,
    m,
    s
  };
}
const bundle = [{
  label: 'El Protocolo GUT de 21 días',
  sub: 'Protocolo Principal',
  accent: false
}, {
  label: 'Lista de la Compra Inteligente',
  sub: 'Bonus 1 · GRATIS',
  accent: true
}, {
  label: 'Guía de Seguimiento Diario',
  sub: 'Bonus 2 · GRATIS',
  accent: true
}];
const inlineTrust = [{
  icon: Download,
  label: 'Descarga Inmediata'
}, {
  icon: LockIcon,
  label: 'Pago Seguro SSL'
}, {
  icon: HeartHandshake,
  label: 'Garantía 30 días'
}];
const reinforceBadges = [{
  icon: ShieldCheck,
  title: 'Pago Encriptado',
  sub: 'Shopify Checkout · 256-bit'
}, {
  icon: Award,
  title: 'Sello de Calidad',
  sub: 'Protocolo revisado y testado'
}];
export function PricingClose() {
  const {
    h,
    m,
    s
  } = useCountdown(24);
  return <section id="pricing" className="py-20 md:py-36 bg-cream-warm scroll-mt-20" data-id="element-129">
      <div className="container mx-auto px-3 sm:px-6 max-w-2xl" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="bg-white rounded-[2rem] px-4 py-10 sm:px-8 sm:py-14 md:px-14 md:py-16 shadow-xl shadow-forest/10 border border-salvia/30 relative overflow-hidden" data-id="element-131">
          {/* Discount Sticker */}
          <motion.div initial={{
          rotate: -12,
          scale: 0,
          opacity: 0
        }} whileInView={{
          rotate: -12,
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 180,
          delay: 0.4
        }} className="absolute top-3 right-3 md:top-6 md:right-6 w-16 h-16 md:w-24 md:h-24 bg-coral text-white rounded-full flex flex-col items-center justify-center shadow-xl shadow-coral/40 border-2 border-white ring-2 ring-coral/30 z-10" data-id="element-132">
            <span className="text-xl md:text-3xl font-black leading-none tracking-tight" data-id="element-133">
              80%
            </span>
            <span className="text-[9px] md:text-xs font-bold tracking-[0.2em] mt-0.5 md:mt-1" data-id="element-134">
              DTO
            </span>
          </motion.div>

          {/* Launch Offer Badge */}
          <div className="flex justify-center mb-5" data-id="element-135">
            <div className="inline-flex items-center gap-2 bg-salvia/20 border border-salvia/40 text-forest text-[11px] md:text-xs font-black tracking-[0.18em] uppercase px-4 py-2 rounded-full" data-id="element-136">
              <Sparkles className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-137" />
              <span data-id="element-138">Oferta de Lanzamiento</span>
            </div>
          </div>

          {/* Title */}
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-semibold text-forest tracking-tight text-center leading-[1.1] mb-3" data-id="element-139">
            Llévate el pack completo
          </h2>
          <p className="text-center text-forest/65 text-sm sm:text-base md:text-lg mb-8 sm:mb-10 max-w-md mx-auto px-2" data-id="element-140">
            Acceso inmediato al Protocolo GUT y a los 2 bonus exclusivos.
          </p>

          {/* Bundle list */}
          <ul className="flex flex-col gap-3 mb-10 sm:mb-12" data-id="element-141">
            {bundle.map((b, i) => <li key={i} className={`flex items-start gap-3 rounded-2xl p-4 ${b.accent ? 'bg-salvia/15 border border-salvia/35' : 'bg-olive border border-salvia/30'}`} data-id="element-142">
                <span className="w-7 h-7 rounded-full flex items-center justify-center shrink-0 mt-0.5 bg-forest text-white" data-id="element-143">
                  <Check className="w-4 h-4" strokeWidth={3} data-id="element-144" />
                </span>
                <div className="min-w-0 flex-1" data-id="element-145">
                  <div className={`text-[10px] font-black tracking-[0.2em] uppercase mb-0.5 ${b.accent ? 'text-salvia' : 'text-forest/55'}`} data-id="element-146">
                    {b.sub}
                  </div>
                  <div className="text-sm md:text-base text-forest font-semibold tracking-tight leading-snug" data-id="element-147">
                    {b.label}
                  </div>
                </div>
              </li>)}
          </ul>

          {/* ===== PRICE BLOCK — máxima jerarquía ===== */}
          <div className="relative bg-gradient-to-b from-cream to-cream-warm rounded-3xl p-5 sm:p-7 md:p-9 border-2 border-salvia/30 mb-8" data-id="element-148">
            {/* Solo hoy pill */}
            <div className="flex justify-center mb-3" data-id="element-149">
              <span className="inline-flex items-center gap-1.5 bg-coral text-white text-[10px] md:text-[11px] font-black tracking-[0.22em] uppercase px-3 py-1.5 rounded-full shadow-md shadow-coral/30" data-id="element-150">
                <span className="relative flex h-1.5 w-1.5" data-id="element-151">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-152"></span>
                  <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-white" data-id="element-153"></span>
                </span>
                Solo hoy
              </span>
            </div>

            {/* 49,90€ tachado */}
            <div className="text-center mb-1" data-id="element-154">
              <span className="text-[10px] font-bold tracking-[0.25em] uppercase text-forest/45 block mb-2" data-id="element-155">
                Antes
              </span>
              <span className="relative inline-block text-2xl sm:text-3xl md:text-4xl text-forest/40 font-medium" data-id="element-156">
                49,90€
                <span aria-hidden className="absolute left-[-6%] right-[-6%] top-1/2 h-[3px] bg-coral rounded-full -rotate-6" data-id="element-157" />
              </span>
            </div>

            {/* Arrow */}
            <div className="flex justify-center my-2 text-forest/30 text-2xl leading-none" data-id="element-158">
              ↓
            </div>

            {/* 9,90€ protagonista */}
            <p className="text-center text-[10px] sm:text-[11px] font-black tracking-[0.25em] uppercase text-coral mb-1" data-id="element-159">
              Hoy
            </p>
            <div className="flex items-start justify-center mb-3 px-2" data-id="element-160">
              <span className="text-[5rem] sm:text-[6.5rem] md:text-[8.5rem] font-black tracking-[-0.05em] text-forest leading-none whitespace-nowrap font-serif" data-id="element-161">
                9,90€
              </span>
            </div>

            <p className="text-center text-sm md:text-base text-coral font-bold tracking-tight" data-id="element-162">
              Ahorras 40€ · 80% de descuento
            </p>
          </div>

          {/* Lifetime access line */}
          <div className="flex items-center justify-center gap-2 mb-6 sm:mb-8 text-sm md:text-[15px] text-forest/75 font-semibold max-w-md mx-auto text-center leading-snug px-2" data-id="element-163">
            <InfinityIcon className="w-4 h-4 text-salvia shrink-0" strokeWidth={2.5} data-id="element-164" />
            <span data-id="element-165">
              Acceso instantáneo de por vida + Actualizaciones futuras
            </span>
          </div>

          {/* Countdown */}
          <div className="flex justify-center mb-8 sm:mb-10" data-id="element-166">
            <div className="inline-flex flex-col items-center gap-2.5 bg-cream border border-salvia/35 rounded-2xl px-5 sm:px-6 py-3.5 sm:py-4 shadow-sm" data-id="element-167">
              <span className="text-[10px] font-bold text-forest tracking-[0.25em] uppercase flex items-center gap-1.5" data-id="element-168">
                <span className="relative flex h-1.5 w-1.5" data-id="element-169">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-coral opacity-75" data-id="element-170"></span>
                  <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-coral" data-id="element-171"></span>
                </span>
                Termina en
              </span>
              <div className="flex items-center gap-2 sm:gap-3" data-id="element-172">
                {[{
                v: h,
                l: 'h'
              }, {
                v: m,
                l: 'm'
              }, {
                v: s,
                l: 's'
              }].map((u, i) => <Fragment key={u.l} data-id="element-173">
                    <div className="flex items-baseline gap-0.5 sm:gap-1" data-id="element-174">
                      <span className="text-xl sm:text-2xl md:text-3xl font-bold tabular-nums text-forest leading-none font-mono" data-id="element-175">
                        {u.v}
                      </span>
                      <span className="text-[10px] sm:text-xs font-semibold text-forest/40 uppercase" data-id="element-176">
                        {u.l}
                      </span>
                    </div>
                    {i < 2 && <span className="text-forest/20 font-light" data-id="element-177">·</span>}
                  </Fragment>)}
              </div>
            </div>
          </div>

          {/* ===== THE BUTTON — thumb-friendly ===== */}
          <motion.a href="https://vyralea.com/cart/55754971611476:1" whileHover={{
          scale: 1.015,
          y: -2
        }} whileTap={{
          scale: 0.985,
          y: 0
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 20
        }} id="buy" className="block w-full bg-forest text-white px-4 py-7 sm:px-8 sm:py-8 md:py-9 rounded-full text-base sm:text-lg md:text-xl font-bold uppercase tracking-tight hover:bg-forest-dark transition-[background-color,box-shadow] shadow-xl shadow-forest/30 hover:shadow-2xl hover:shadow-forest/50 mb-4 scroll-mt-24 text-center min-h-[64px] flex items-center justify-center" data-id="element-178">
            SÍ, QUIERO MI PROTOCOLO POR 9,90€
          </motion.a>

          {/* ===== Inline trust row — directamente bajo el botón ===== */}
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 mb-6 px-2" data-id="element-179">
            {inlineTrust.map((t, i) => {
            const Icon = t.icon;
            return <div key={i} className="inline-flex items-center gap-1.5 text-[11px] sm:text-xs font-semibold text-forest/75 tracking-tight" data-id="element-180">
                  <Icon className="w-3.5 h-3.5 text-salvia" strokeWidth={2.25} data-id="element-181" />
                  <span data-id="element-182">{t.label}</span>
                </div>;
          })}
          </div>

          {/* Social proof */}
          <p className="text-center text-sm text-forest/70 font-medium mb-1.5 tracking-tight" data-id="element-183">
            Únete a otras +1.200 mujeres que ya han recuperado su ligereza
          </p>
          <p className="text-center text-xs text-forest/45 font-medium mb-8 tracking-tight" data-id="element-184">
            Pago único · Acceso de por vida
          </p>

          {/* Reinforce trust — 2 cards (Pago + Sello) */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-2" data-id="element-185">
            {reinforceBadges.map((b, i) => {
            const Icon = b.icon;
            return <div key={i} className="flex items-center text-left gap-3 bg-cream rounded-2xl p-4 border border-salvia/30" data-id="element-186">
                  <span className="w-11 h-11 rounded-full bg-salvia/20 flex items-center justify-center shrink-0" data-id="element-187">
                    <Icon className="w-5 h-5 text-forest" strokeWidth={2.25} data-id="element-188" />
                  </span>
                  <div className="min-w-0" data-id="element-189">
                    <div className="text-[13px] font-bold text-forest tracking-tight" data-id="element-190">
                      {b.title}
                    </div>
                    <div className="text-[11px] text-forest/55 font-medium leading-snug mt-0.5" data-id="element-191">
                      {b.sub}
                    </div>
                  </div>
                </div>;
          })}
          </div>

          {/* Payment logos row */}
          <div className="flex flex-wrap items-center justify-center gap-2 opacity-75 mt-6" data-id="element-192">
            <div className="h-6 px-2 rounded bg-white border border-forest/10 flex items-center justify-center text-[9px] font-black tracking-tight text-forest/50" data-id="element-193">
              VISA
            </div>
            <div className="h-6 px-1.5 rounded bg-white border border-forest/10 flex items-center justify-center gap-0.5" data-id="element-194">
              <span className="w-2.5 h-2.5 rounded-full bg-forest/30" data-id="element-195"></span>
              <span className="w-2.5 h-2.5 rounded-full bg-salvia/60 -ml-1 mix-blend-multiply" data-id="element-196"></span>
            </div>
            <div className="h-6 px-2 rounded bg-white border border-forest/10 flex items-center justify-center text-[9px] font-black tracking-tight text-forest/50" data-id="element-197">
              PayPal
            </div>
            <span className="ml-1 inline-flex items-center gap-1 text-[10px] text-forest/40 font-medium" data-id="element-198">
              <LockIcon className="w-2.5 h-2.5" data-id="element-199" />
              <span data-id="element-200">SSL 256-bit</span>
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}